// extracted by mini-css-extract-plugin
export default {"templateButton":"styles_templateButton__0QuRt","templateIconButton":"styles_templateIconButton__r0OO0"};